// This file is automatically compiled by Webpack, along with any other files
// present in this directory. Place app logic in app/javascript/* and only require it here.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../stylesheets/tailwind.css"
import "../stylesheets/application.scss"
import { initWhitegloveIndexTable } from "../whiteglove_index_table"
import { initUploaderWizard } from "../uploader_wizard"
import { initAppUi } from "../app_ui"
import { initAppBusy } from "../app_busy"
import { initFlowbite } from "flowbite"
import $ from "jquery"

window.jQuery = window.$ = $

Rails.start()
Turbolinks.start()
ActiveStorage.start()

function onTurbolinksLoad() {
  initAppBusy()
  initAppUi()
  initFlowbite()
  initWhitegloveIndexTable()
  initUploaderWizard()
  scheduleFlashFadeOut()
}

function scheduleFlashFadeOut() {
  window.setTimeout(function () {
    $(".app-flash").fadeTo(500, 0, function () {
      $(this).remove()
    })
  }, 3000)
}

$(document).on("turbolinks:load", onTurbolinksLoad)

$(document).on("turbolinks:before-cache", function () {
  if (typeof document === "undefined") return
  /* Flowbite modals: avoid leaving backdrops / scroll lock on snapshot */
  document
    .querySelectorAll('[role="dialog"][aria-modal="true"]')
    .forEach((el) => {
      el.classList.add("hidden")
      el.classList.remove("flex")
      el.setAttribute("aria-hidden", "true")
      el.removeAttribute("aria-modal")
      el.removeAttribute("role")
    })
  document.body.classList.remove("overflow-hidden")
  document.querySelectorAll("body > div.fixed.inset-0.z-40").forEach((el) => {
    if (el.className.includes("bg-gray-900")) el.remove()
  })
  document.querySelectorAll("dialog[open]").forEach((d) => d.close && d.close())
})

// Eligibility bulk form: no jQuery — native delegation; works when Turbolinks replaces the body.
function syncEligibilityActionButtons() {
  const root = document.getElementById("patient-list")
  if (!root) return
  const n = root.querySelectorAll("input[type=checkbox].checkbox-enrollment:checked").length
  document.querySelectorAll(".action-buttons").forEach((el) => {
    if (n === 0) {
      el.classList.add("hidden")
    } else {
      el.classList.remove("hidden")
    }
  })
  if (n === 0) {
    document.querySelectorAll(".process-filters").forEach((el) => {
      el.classList.add("hidden")
    })
  }
}

if (typeof document !== "undefined") {
  document.addEventListener("change", function (e) {
    const t = e.target
    if (!(t instanceof HTMLInputElement)) return
    if (t.type !== "checkbox" || !t.classList.contains("checkbox-enrollment")) return
    if (!t.closest("#patient-list")) return
    syncEligibilityActionButtons()
  })
  document.addEventListener("click", function (e) {
    if (!(e.target instanceof Element)) return
    const a = e.target.closest("a.select-all")
    if (!a || !a.closest("#patient-list")) return
    e.preventDefault()
    for (const cb of document.querySelectorAll("#patient-list input[type=checkbox].checkbox-enrollment")) {
      cb.checked = !cb.checked
    }
    syncEligibilityActionButtons()
  })
}

// Payers / process UI: jQuery + delegation (one binding for the app lifetime; Turbolinks-safe)
$(function () {
  /** UI filter: rows with a non-blank Availity ID (hidden input reflects mapping done in-session). */
  function payersRowHasAvailityId(rowEl) {
    const finp = rowEl.querySelector(
      'form.allforms input[name*="mapped_availity_id"], input.mapped_availity_id'
    )
    if (finp && String(finp.value || "").trim() !== "") {
      return true
    }
    return rowEl.getAttribute("data-availity-set") === "true"
  }

  function applyPayersHideMapped() {
    const $table = $("#payers-map-table")
    const $cb = $("#payers-hide-mapped")
    if (!$table.length || !$cb.length) {
      return
    }
    const shouldHide = $cb.is(":checked")
    $table.find("tbody tr.payermap-row").each(function () {
      if (shouldHide && payersRowHasAvailityId(this)) {
        this.classList.add("hidden")
      } else {
        this.classList.remove("hidden")
      }
    })
  }

  $(document).on("change", "#payers-hide-mapped", function () {
    applyPayersHideMapped()
  })
  // Re-apply when returning via Turbolinks and the table is in the body again.
  $(document).on("turbolinks:load", function () {
    if ($("#payers-map-table").length && $("#payers-hide-mapped").is(":checked")) {
      applyPayersHideMapped()
    }
  })

  $(document).on("click", ".processtoggles", function () {
    const url = "/count_all/"
    const myForm = $('form[name="filterform"]')
    const valuesToSend = myForm.serialize()
    $.ajax(url, { method: "GET", data: valuesToSend }).then(function (resp) {
      const parsed = $.parseJSON(resp)
      $("#totaltoprocess").html("Filter result count: " + parsed)
    })
  })

  // Multi-select only (e.g. insurance filters). Do not bind to all <select> options — it breaks
  // single-select dropdowns (e.g. payers “Matches”): change/submit never fires reliably.
  $(document).on("mousedown", "select[multiple] option", function (e) {
    e.preventDefault()
    $(this).prop("selected", !$(this).prop("selected"))
    return false
  })

  $(document).on("click", ".processbutton", function () {
    $(".process-filters").toggleClass("hidden")
  })

  /** Fill each row’s Search field with the first word of “Payer in import”, then run the same lookup as the “?” button. */
  $(document).on("click", "#payers-auto-search", function (event) {
    event.preventDefault()
    $("#payers-map-table tbody tr.payermap-row").each(function () {
      const $tr = $(this)
      const raw = String($tr.attr("data-csv-value") || "").trim()
      const firstWord = raw.split(/\s+/).filter(Boolean)[0] || ""
      $tr.find("input.search").val(firstWord)
      if (firstWord) {
        $tr.find(".search_payers").trigger("click")
      }
    })
  })

  // Pressing Enter in the Search input should run the same lookup as clicking "?".
  // (Otherwise the form may submit and trigger "Save" behavior instead.)
  $(document).on("keydown", "#payers-map-table input.search", function (event) {
    if (event.key !== "Enter") return
    event.preventDefault()
    $(event.target).closest("tr").find(".search_payers").trigger("click")
  })

  $(document).on("click", ".search_payers", function (event) {
    event.preventDefault()
    const search = $(event.target).closest("tr").find(".search")
    const dropdown = $(event.target).closest("tr").find(".payer_selection")
    dropdown.empty()
    dropdown.append('<option selected="true" disabled>Payers Found</option>')
    dropdown.prop("selectedIndex", 0)
    const url = "/payers/searchpayers?query=" + encodeURIComponent(search.val())
    $.getJSON(url, function (data) {
      $.each(data.data, function (_key, entry) {
        const extra = entry.id === "" ? " (No Availity Payer)" : ""
        dropdown.append(
          $("<option></option>").attr("value", entry.id).text(entry.name + extra)
        )
      })
    })
  })

  $(document).on("change", ".payer_selection", function (e) {
    const sel = e.target
    const $outer = $(sel).closest("tr.payermap-row")
    if (!$outer.length) return
    const dropdown = $(sel)
    const $selected = dropdown.children("option").filter(":selected")
    if ($selected.prop("disabled")) {
      return
    }
    const text = $selected.text()
    $outer.find(".availity_id").html(dropdown.val())
    $outer.find(".standardized_payer").html(text)
    $outer.find("input.mapped_availity_id").val(dropdown.val())
    $outer.find("input.mapped_name").val(text)
    const idVal = String($outer.find("input.mapped_availity_id").val() || "").trim()
    $outer[0].setAttribute("data-availity-set", idVal ? "true" : "false")
    applyPayersHideMapped()

    const form = $outer.find("form.allforms")[0]
    if (!form) {
      return
    }
    const btn = form.querySelector('input[type="submit"][name="commit"]')
    // Prefer native submit path so Rails UJS remote handler runs (same as clicking Save).
    if (btn && typeof form.requestSubmit === "function") {
      form.requestSubmit(btn)
    } else if (btn) {
      btn.click()
    } else if (typeof Rails !== "undefined" && typeof Rails.fire === "function") {
      Rails.fire(form, "submit")
    }
  })
})
